import '@draft-js-plugins/static-toolbar/lib/plugin.css';
import './useEditorToolbar.scss';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import { BoldButton, HeadlineOneButton, HeadlineThreeButton, HeadlineTwoButton, ItalicButton, OrderedListButton, UnderlineButton, UnorderedListButton } from '@draft-js-plugins/buttons';
import createEmojiPlugin from '@draft-js-plugins/emoji';
import createToolbarPlugin from '@draft-js-plugins/static-toolbar';
import React, { useMemo } from 'react';
export const useEditorToolbar = () => {
    const { EmojiSelect, EmojiSuggestions, Toolbar, plugins } = useMemo(() => {
        const emojiSymbol = '😀';
        const staticToolbarPlugin = createToolbarPlugin();
        const linkifyPlugin = createLinkifyPlugin({
            component(props) {
                return (React.createElement("a", Object.assign({}, props, { onClick: () => window.open(props.href) }), props.children));
            },
            rel: 'noopener',
            target: '_blank'
        });
        const emojiPlugin = createEmojiPlugin({
            selectButtonContent: React.createElement("div", { className: 'grey-emoji' }, emojiSymbol),
            useNativeArt: true
        });
        return {
            EmojiSelect: emojiPlugin.EmojiSelect,
            EmojiSuggestions: emojiPlugin.EmojiSuggestions,
            Toolbar: staticToolbarPlugin.Toolbar,
            plugins: [staticToolbarPlugin, emojiPlugin, linkifyPlugin]
        };
    }, []);
    const toolbar = React.createElement("div", { className: 'toolbar' },
        React.createElement(Toolbar, null, (externalProps) => React.createElement(React.Fragment, null,
            React.createElement(BoldButton, Object.assign({}, externalProps)),
            React.createElement(ItalicButton, Object.assign({}, externalProps)),
            React.createElement(UnderlineButton, Object.assign({}, externalProps)),
            React.createElement("div", { className: 'hTagButtons' },
                React.createElement(HeadlineOneButton, Object.assign({}, externalProps)),
                React.createElement(HeadlineTwoButton, Object.assign({}, externalProps)),
                React.createElement(HeadlineThreeButton, Object.assign({}, externalProps))),
            React.createElement(UnorderedListButton, Object.assign({}, externalProps)),
            React.createElement(OrderedListButton, Object.assign({}, externalProps)),
            React.createElement(EmojiSuggestions, null),
            React.createElement("div", { className: 'emoji-select' },
                React.createElement(EmojiSelect, null)))));
    return {
        plugins,
        toolbar
    };
};
